<template>
	<c-basic-modal
		:show.sync="sync_show"
		align="center"
		show-action-button
		:success-callback="gotoFaq"
		success-message="소셜 계정 연동 신청하기"
	>
		<template v-slot:title> 페이스북 소셜로그인 일시 중단 안내 </template>
		<template v-slot:content>
			페이스북 계정 로그인 기능이 한시적으로 중단됩니다.<br />
			아래 버튼을 클릭하여 요청주시면<br />
			다른 소셜 계정을 이용해 로그인 하실 수 있도록 조치해드리겠습니다.
		</template>
	</c-basic-modal>
</template>

<script>
import routeMixin from '@/mixins/routeMixin';
export default {
	name: 'FacebookLoginAlert',
	mixins: [routeMixin],
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		sync_show: {
			get() {
				return this.show;
			},
			set(value) {
				this.$emit('update:show', value);
			},
		},
	},
	methods: {
		gotoFaq() {
			this.$_routeMixin_href('/help');
		},
	},
};
</script>

<style scoped></style>
